<template>
  <div class="seller-page login seller">
    <div class="inner-page py-3 px-2">
      <div class="text-center logo-wrapper py-2 mb-1">
        <img src="../../../../public/img/logos/logo-2.png" />
      </div>
      <h3 class="golpino-color text-center">به گلپینو خوش آمدید</h3>

      <div class="seller-form mt-4 px-2 pt-3 pb-1">
        <div class="mb-1" v-if="this_status == 0">
          <p class="my-text text-center">
            برای ورود / ثبت نام شماره موبایل خود را وارد کنید
          </p>
          <div>
            <div class="my-text">موبایل:</div>
            <v-text-field
              v-model="mobile"
              name="input-10-2 pt-0"
              class="input-group--focused text-color text-center"
              @keyup.enter="sellerLogin"
            ></v-text-field>
          </div>

          <div class="sellerSend py-4">
            <button class="purple-btn pink" @click="sellerLogin">ادامه</button>
          </div>
        </div>
        <div class="mb-1" v-if="this_status == 1">
          <p class="my-text text-center">لطفا کد ارسالی را وارد کنید:</p>
          <div>
            <div class="my-text">کد:</div>
            <v-text-field
              v-model="sent_code"
              class="input-group--focused text-color text-center"
            ></v-text-field>
          </div>
          <button @click="resend_code()" class="resend">ارسال مجدد کد</button>

          <div class="sellerSend py-4">
            <button class="purple-btn pink" @click="check_code()">ادامه</button>
          </div>
        </div>
        <div class="mb-1" v-if="this_status == 2">
          <p class="my-text text-center">
            لطفا نام و رمز عبور را دلخواه را وارد کنید:
          </p>
          <div>
            <div class="my-text">نام:</div>
            <v-text-field
              v-model="my_name"
              class="input-group--focused text-color pt-0"
            ></v-text-field>
          </div>
          <div>
            <div class="my-text">رمز عبور:</div>
            <v-text-field
              type="password"
              v-model="my_new_password"
              class="input-group--focused text-color pt-0"
            ></v-text-field>
            <div class="my-text">تکرار رمز عبور:</div>
            <v-text-field
              type="password"
              v-model="my_new_re_password"
              class="input-group--focused text-color pt-0"
            ></v-text-field>
            <p v-if="not_match" class="text-center my-alarm mini">
              رمز عبور و تکرار آن یکی نیستند!
            </p>
          </div>
          <button @click="resend_code()" class="resend">ارسال مجدد کد</button>
          <div class="sellerSend py-4">
            <button class="purple-btn pink" @click="add_info()">ادامه</button>
          </div>
        </div>
        <div class="mb-1" v-if="this_status == 3 || this_status == 4">
          <div v-if="!on_pass_on">
            <p class="my-text text-center">لطفا رمز عبور را وارد کنید:</p>
            <div>
              <div class="my-text">رمز عبور:</div>
              <v-text-field
                type="password"
                v-model="my_password"
                class="input-group--focused text-color pt-0"
              ></v-text-field>
            </div>
          </div>
          <div v-if="on_pass_on">
            <p class="my-text text-center">لطفا کد ارسالی را وارد کنید:</p>
            <div>
              <div class="my-text">کد:</div>
              <v-text-field
                v-model="one_code_sent"
                class="input-group--focused text-color pt-0"
              ></v-text-field>
            </div>
          </div>
          <button @click="one_pass()" class="resend">
            ورود با رمز یک بار مصرف
          </button>
          <div class="sellerSend py-4">
            <button v-if="!on_pass_on" class="purple-btn pink" @click="go()">
              ادامه
            </button>
            <button
              v-if="on_pass_on"
              class="purple-btn pink"
              @click="check_code_one()"
            >
              ادامه
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomInput from "../../Common/CustomInput";
import {
  ref,
  computed,
  inject,
  onMounted,
  watch,
  reactive,
} from "@vue/composition-api";
import Service from "../../../utils/seller-service";

export default {
  components: {
    CustomInput,
  },
  setup(props, context) {
    onMounted(() => {
      if (global.user.value.isLoggedIn) {
        context.root.$router.push("/seller/dashboard");
      }
      // global.user.value.isLoggedIn = false
    });
    // component
    const global = inject("global");
    const authStep = ref(-1);
    const this_status = ref(0);
    const sent_code = ref(null);
    const theService = computed(() => {
      return Service(false);
    });
    const ServiceToken = computed(() => {
      return Service(true);
    });
    const show = ref(false);
    const mobile = ref(null);
    const not_match = ref(false);
    const my_new_password = ref(null);
    const my_new_re_password = ref(null);
    const my_password = ref(null);
    const my_name = ref(null);
    const one_code_sent = ref(null);
    const on_pass_on = ref(false);
    const user_status = ref(null);
    const password = ref({ value: null, valid: true });
    const rePassword = ref({ value: null, valid: true });
    const code = ref({ value: null, valid: true });
    const name = ref({ value: null, valid: true });

    const forgotPassword = () => {
      authStep.value = 9;
      context.root.$router.push("/forget");
    };
    const goToRegister = () => {
      context.root.$router.push("/register");
    };

    const sellerLogin = () => {
      let form_data = new FormData();
      // login
      form_data.append("mobile", mobile.value);
      theService.value.transmit(
        "seller/register/checkseller",
        form_data,
        (success, data) => {
          if (success == 200) {
            console.log("this is status");
            console.log(data.data.status);
            this_status.value = data.data.status;
          }
        },
        (success, error) => {
          global.alertToggle("مشکلی در ارسال وجود دارد");
        }
      );
    };

    const check_code = () => {
      let form_data = new FormData();
      // login
      form_data.append("mobile", mobile.value);
      form_data.append("code", sent_code.value);
      theService.value.transmit(
        "seller/register/checkcode",
        form_data,
        (success, data) => {
          if (success == 200) {
            console.log("this is status");
            console.log(data.data.token);
            this_status.value = 2;
            $cookies.set("Golpino_seller", data.data.token, 2147483647);
          }
        },
        (success, error) => {
          global.alertToggle("مشکلی در ارسال وجود دارد");
          console.log(error);
        }
      );
    };
    const check_code_one = () => {
      let form_data = new FormData();
      form_data.append("mobile", mobile.value);
      form_data.append("code", one_code_sent.value);
      theService.value.transmit(
        "seller/register/checkcode",
        form_data,
        (success, data) => {
          if (success == 200) {
            $cookies.set("Golpino_seller", data.data.token, 2147483647);
            global.toggleLogin(true);
            global.setUserType("seller");
            context.root.$router.push("/seller/dashboard");
          }
        },
        (success, error) => {
          global.alertToggle("مشکلی در ارسال وجود دارد");
          console.log(error);
        }
      );
    };

    const add_info = () => {
      let form_data = new FormData();
      form_data.append("name", my_name.value);
      form_data.append("password", my_new_password.value);
      if (my_new_password.value == my_new_re_password.value) {
        ServiceToken.value.transmit(
          "seller/register/addinfo",
          form_data,
          (success, data) => {
            if (success == 200) {
              console.log(data);
              global.toggleLogin(true);
              global.setUserType("seller");
              context.root.$router.push("/seller/dashboard");
              this_status.value = 3;
            }
          },
          (success, e) => {}
        );
      } else {
        not_match.value = true;
      }
    };
    const one_pass = () => {
      let form_data = new FormData();
      form_data.append("mobile", mobile.value);
      theService.value.transmit(
        "seller/register/resendcode",
        form_data,
        (success, data) => {
          if (success == 200) {
            global.alertToggle("کد جدید ارسال شد");
            on_pass_on.value = true;
          }
        },
        (success, error) => {
          global.alertToggle("مشکلی در ارسال وجود دارد");
        }
      );
    };
    const go = () => {
      let form_data = new FormData();
      form_data.append("mobile", mobile.value);
      form_data.append("password", my_password.value);
      theService.value.transmit("seller/login", form_data, (success, data) => {
        if (success == 200) {
          $cookies.set("Golpino_seller", data.data.token, 2147483647);
          global.toggleLogin(true);
          global.setUserType("seller");
          context.root.$router.push("/seller/dashboard");
        }
      });
    };
    const resend_code = () => {
      let form_data = new FormData();
      // login
      form_data.append("mobile", mobile.value);
      theService.value.transmit(
        "seller/register/resendcode",
        form_data,
        (success, data) => {
          if (success == 200) {
            global.alertToggle("کد جدید ارسال شد");
          }
        },
        (success, error) => {
          global.alertToggle("مشکلی در ارسال وجود دارد");
        }
      );
    };

    return {
      not_match,
      mobile,
      password,
      sellerLogin,
      rePassword,
      name,
      code,
      forgotPassword,
      authStep,
      show,
      goToRegister,
      this_status,
      theService,
      user_status,
      sent_code,
      resend_code,
      check_code,
      my_name,
      my_new_password,
      my_password,
      add_info,
      ServiceToken,
      my_new_re_password,
      one_pass,
      on_pass_on,
      one_code_sent,
      go,
      check_code_one,
    };
  },
};
</script>
<style lang="scss" scoped>
.seller-page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  &.login {
    margin-bottom: -100px;
    .inner-page {
      position: absolute;
      left: 50%;
      top: 50%;
      max-width: 500px;
      transform: translate(-50%, -50%);
      width: 60%;
      background: white;
      border-radius: 10px;
      @media only screen and (max-width: 600px) {
        width: 95%;
      }
    }
    .theme--light.v-input,
    .theme--light.v-input input,
    .theme--light.v-input textarea {
      color: #fc3e9a;
    }
  }
}

.pink {
  background: #fc57a8;
  outline: none;
  &:hover {
    font-weight: bold;
    color: #fff !important;
    background: #fc3e9a;
  }
}
.tool-paragrapgh {
  // color: #0498db;
  color: #fe5eda;
}

.tool-paragrapgh:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #fd45a7;
}

.seller-tab-bar {
  background-color: #fff;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.seller-tab-bar .active {
  background-color: rgba(127, 127, 127, 0.1);
}

.seller-form {
  border-radius: 8px;
  margin-right: auto;
  margin-left: auto;
}

.sellerSend button {
  width: 100%;
}
.logo-wrapper {
  img {
    width: 45px;
  }
}
.my-text {
  font-size: 14px;
  color: #525252;
}
.text-color {
  color: #525252;
}
.resend {
  font-size: 12px;
  padding: 7px 10px;
  color: #eb307b;
  border-radius: 5px;
  outline: none;
  border: solid 1px #eb307b;
  &:focus {
    outline: none;
  }
  &:hover {
    font-weight: bold;
    border: solid 1px #e6176a;
  }
}
</style>
<style>
.login .v-text-field__slot input {
  text-align: center;
}
</style>